<template>
  <div class="min-h-[900px]">
    <main class="pb-0 md:pb-24">
      <section
        class="flex flex-col items-center pt-16 pb-0 md:pb-16 lg:pt-[102px] lg:pb-[157px]"
      >
        <div class="mx-auto min-w-[320px] max-w-[1010px] px-4">
          <h1 class="landing_h1 mb-4 text-center">
            <Translate translate-key="page_data.contacts.h1" />
          </h1>
          <p>
            <Translate
              translate-key="contacts.contact_intro"
              :translate-options="{ link: localePath('/faq') }"
            />
          </p>
        </div>
        <div
          class="w-full mx-0 px-4 md:mx-auto my-0 mt-4 md:my-16 min-w-[300px] max-w-[1000px]"
        >
          <div
            class="mb-0 md:mb-16 w-full rounded-lg bg-white px-8 py-5 shadow-[0px_0px_35px_rgba(0,0,0,0.08)] lg:px-16"
          >
            <ul
              class="list-none p-0 text-sm leading-[1.9] text-black lg:text-xl"
            >
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.google.com/maps/place/Regus+-+California,+Commerce+-+Commerce+Corporate+Center/@33.9781429,-118.2790945,11z/data=!4m5!3m4!1s0x80c2ce5eaaaaaaa9:0x72c4ed4517982fc!8m2!3d33.9854!4d-118.162"
                  class="text-black opacity-60 transition-opacity hover:opacity-100 focus:opacity-100"
                >
                  <Translate translate-key="contacts.gfs_address" />
                </a>
              </li>
              <li v-if="settings?.['business-hours']" class="my-5 mx-auto">
                <span class="mr-2">
                  {{ settings["business-hours"]?.attribute?.name }}:
                </span>
                {{ settings["business-hours"]?.value }}
              </li>
              <li v-if="currentUserStore.isShowPhoneNumber">
                <span class="mr-2">
                  <Translate translate-key="common.phone" />:
                </span>
                <PhoneLink />
              </li>
              <li v-if="settings?.email?.value">
                <span class="mr-2"> Email: </span>
                <a
                  :href="`mailto:${settings.email.value}`"
                  class="text-black opacity-60 transition-opacity hover:opacity-100 focus:opacity-100"
                >
                  {{ settings.email.value }}
                </a>
              </li>
              <li class="mt-5">
                <SocialLinks :white="false" />
              </li>
            </ul>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>
<script setup lang="ts">
import Translate from "~/shared/components/i18n/Translate/Translate.vue";
import SocialLinks from "~/shared/components/layout/SocialLinks.vue";
import PhoneLink from "~/shared/components/layout/PhoneLink.vue";
import { useSettingsStore } from "@/stores/settingsStore";
import { useCurrentUserStore } from "@/stores/userStore";
import { useI18n } from "vue-i18n";

definePageMeta({ layout: "public" });

const localePath = useLocalePath();
const { settings } = useSettingsStore();
const currentUserStore = useCurrentUserStore();
const { t } = useI18n();
const config = useRuntimeConfig();
const route = useRoute();
const siteUrl = (config.public.siteUrl as string) || "";

useSeoMeta({
  title: () => t("page_data.contacts.seo_title"),
  description: () => t("page_data.contacts.seo_description"),
  ogTitle: () => t("page_data.contacts.seo_title"),
  ogDescription: () => t("page_data.contacts.seo_description"),
  ogUrl: () => (siteUrl ? `${siteUrl}${route.path}` : undefined),
  ogImage: () => (siteUrl ? `${siteUrl}/home/gfs-group-tradelines-for-sale-800w.webp` : undefined),
  ogImageAlt: () => t("index_page.image_alt_content"),
});
useHead(() => ({
  meta: [{ name: "keywords", content: t("page_data.contacts.seo_keywords") }],
}));
</script>
